import {
  ADD_MESSAGE,
  UPLOAD_IMAGE,
  FAIL,
  ADD_PICTURE_TO_CANVAS,
  START,
  TICK,
  GET_REALISM,
  SAVE_DESIGN,
  GET_THREE_D_VIEWER,
  RESTORE_DESIGN,
  APPLY_VISIONHUB_FILTER
} from "../constants/action-types";
import {SUCCESS} from "../../../constants";

export default (message = {}, action) => {
  const {type, payload} = action;

  switch (type) {
    case ADD_MESSAGE:
      return {[payload.type]: payload.text};

    case APPLY_VISIONHUB_FILTER + START:
      return {info: `Пожалуйста подождите, изображение обрабатывается`};
    case APPLY_VISIONHUB_FILTER + FAIL:
      return {error: `Произошла ошибка при обработке изображения`};

    case UPLOAD_IMAGE + START:
      return {info: `Пожалуйста подождите, загружается изображение...`};
    case UPLOAD_IMAGE + TICK:
      return {
        info: `Пожалуйста подождите, загружается изображение ${Math.round(
          payload.progress
        )}%`
      };
    case UPLOAD_IMAGE + SUCCESS:
      return {success: `Изображение успешно загружено`};
    case UPLOAD_IMAGE + FAIL:
      return {error: `Произошла ошибка при загрузке`};

    case ADD_PICTURE_TO_CANVAS + START:
      return {info: `Пожалуйста подождите, добавляем изображение...`};
    case ADD_PICTURE_TO_CANVAS + SUCCESS:
      return {success: `Изображение успешно добавлено`};
    case ADD_PICTURE_TO_CANVAS + FAIL:
      return {error: `Произошла ошибка при добавлении`};

    case GET_REALISM + START:
      return {info: `Получение реализма...`};
    case GET_REALISM + SUCCESS:
      return {success: `Успешно`};
    case GET_REALISM + FAIL:
      return {error: `Произошла ошибка при получении реализма`};

    case SAVE_DESIGN + START:
      return {info: `Cохранение...`};
    case SAVE_DESIGN + SUCCESS:
      return {success: `Успешно сохранено`};
    case SAVE_DESIGN + FAIL:
      return {
        error: `Произошла ошибка при сохранении, попробуйте обновить страницу`
      };

    case GET_THREE_D_VIEWER + START:
      return {info: `Подготавливаем 3D модель...`};
    case GET_THREE_D_VIEWER + SUCCESS:
      return {success: `Успешно`};
    case GET_THREE_D_VIEWER + FAIL:
      return {error: `Произошла ошибка при подготовке 3D модели`};

    case RESTORE_DESIGN:
      return {success: `Мы восстановили ваш дизайн`};
  }

  return message;
};
